import { render, staticRenderFns } from "./FieldManager.vue?vue&type=template&id=7d441d91&lang=pug&"
import script from "./FieldManager.vue?vue&type=script&lang=js&"
export * from "./FieldManager.vue?vue&type=script&lang=js&"
import style0 from "./FieldManager.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d441d91')) {
      api.createRecord('7d441d91', component.options)
    } else {
      api.reload('7d441d91', component.options)
    }
    module.hot.accept("./FieldManager.vue?vue&type=template&id=7d441d91&lang=pug&", function () {
      api.rerender('7d441d91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/FieldManager.vue"
export default component.exports